import { render } from "./SideNavDriver.vue?vue&type=template&id=05911707"
import script from "./SideNavDriver.vue?vue&type=script&lang=js"
export * from "./SideNavDriver.vue?vue&type=script&lang=js"

import "./SideNavDriver.vue?vue&type=style&index=0&id=05911707&lang=css"
script.render = render

export default script